"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentPlan = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const PaymentPlan = _ref => {
  let {
    color = "currentColor",
    strokeWidth = 3.2,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 49"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M2 40.82V32.1m0 0h9.031m-9.03 0 9.28 8.72a18 18 0 0 0 29.7-6.72m5.018-24.6v9.8H35.97M45 17.296l-9.28-8.72a18 18 0 0 0-29.7 6.72"
  }), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#payment_plan_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M24 12.4v24.2m5.5-19.8h-8.25a3.85 3.85 0 1 0 0 7.7h5.5a3.85 3.85 0 0 1 0 7.7H17.4"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "payment_plan_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M10.8 11.3h26.4v26.4H10.8z"
  }))));
};
exports.PaymentPlan = PaymentPlan;
PaymentPlan.displayName = "PaymentPlan";